/**
 * Hint next to a finished deposit's status: why it closed, and — for manager/admin, when the client
 * cancelled on the payment page and picked a reason — what the client said.
 */
export const buildCloseReasonHint = (
  closeReasonTitle?: string | null,
  clientCancelReasonTitle?: string | null
): string | undefined => {
  const parts = [
    closeReasonTitle || null,
    clientCancelReasonTitle ? `Причина клиента: ${clientCancelReasonTitle}` : null,
  ].filter((part): part is string => part !== null)

  return parts.length > 0 ? parts.join('. ') : undefined
}
